export default [
    // *===================Bank List============================---*
    {
        path: '/income/:id',
            name: 'income',
            component: () => import('@/views/accounting/income/income.vue'),
            meta: {
                pageTitle: 'Income',
                breadcrumb: [
                    {
                        text: 'Income',
                        active: true,
                    },
                ],
                //permission: 'Permissions.Accounting.View'            
            },
    }
    ]